import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';
import { useForm } from 'react-hook-form';
import { Close } from '@mui/icons-material';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../../utils/methods';
import { FormInputText } from '../../../form-components/FormInputText';
import { createProgramCategory, updateProgramCategory, createPrograms, updatePrograms } from '../../../api/program';
import { useEffect } from 'react';

const BodyCreateModal = ({ getList, type, open, setOpen, data, tableName, getProgram }) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '706px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '20px 30px 20px 30px',
    borderRadius: '10px',
  };

  const toast = useToast();
  const { user } = useSelector(state => state.user);
  const { t } = useTranslation();
  const { handleSubmit, control, setError, reset, setValue } = useForm({
    defaultValues: {
      name: type !== 'create' ? data?.name : '',
      id: data?.id,
    },
  });

  const submit = async values => {
    if (!values.name) {
      return setError('name', {
        type: 'custom',
        message: 'Please input member name',
      });
    }

    try {
      if (tableName === 'categories') {
        const request = {
          name: values.name,
        };
        if (type === 'create') {
          await createProgramCategory(request, user.token);
          toast.success(t('Category created successfully'));
        } else if (type === 'edit') {
          await updateProgramCategory(request, user.token, data.id).then(() => {
            toast.success(t('Program updated successfully'));
          });
        }
        reset();
        handleClose();
        getList();
      } else if (tableName === 'programs') {
        const requestProgram = {
          categoryId: data.catId,
          name: values.name,
        };
        if (type === 'create') {
          await createPrograms(requestProgram, user.token);
          toast.success(t('Program created successfully'));
        } else if (type === 'edit') {
          await updatePrograms(requestProgram, user.token, data.id);
          toast.success(t('Program updated successfully'));
        }
        reset();
        handleClose();
        getProgram(data.catId);
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };
  // useEffect(()=>{
  //   if(data){
  //     setValue('name',data.name)
  //   }
  // },[data])
  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const getTitle = () => {
    switch (tableName) {
      case 'categories':
        return t('Create/edit new category');
      case 'programs':
        return t('Create/edit new programs');
      default:
        return '';
    }
  };
  const getValue = () => {
    switch (tableName) {
      case 'categories':
        return t('Category name');
      case 'programs':
        return t('Program name');
      default:
        return '';
    }
  };
  useEffect(() => {
  }, [data]);

  return (
    <div style={{ display: 'flex' }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={modalStyle}>
          <Typography
            id="modal-modal-title"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
            <Box sx={{ fontSize: '18px' }}>{getTitle()}</Box>
            <button
              onClick={handleClose}
              style={{
                color: 'black',
                width: '40px',
                height: '40px',
                padding: '0px 0px 0px 0px',
                border: '1px solid white',
                backgroundColor: 'white',
              }}>
              <Close
                onChange={handleClose}
                sx={{
                  width: '20px',
                  height: '20px',
                }}></Close>
            </button>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '500px',
              alignItems: 'center',
              marginBottom: '40px',
            }}>
            <Typography
              sx={{
                fontSize: '14px',
              }}>
              {getValue()}
            </Typography>
            <FormInputText
              control={control}
              onMouseOver={e => (e.target.style.cursor = 'pointer')}
              color="info"
              sx={{
                width: '280px',
                height: '30px',
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                },
              }}
              variant="outlined"
              name="name"
              size="small"
              placeholder={
                tableName !== 'programs'
                  ? t('Please enter the category name (within 10 characters)')
                  : t('Please enter the program name (within 10 characters)')
              }
              rules={{ required: true }}></FormInputText>
          </Box>
          <hr></hr>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
            }}>
            <Button
              sx={{
                marginRight: '10px',
                border: '1px solid #0F7F85',
                borderRadius: '8px',
              }}
              onClick={handleClose}>
              {t('CANCEL')}
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: '8px',
              }}
              onClick={handleSubmit(submit)}>
              {t('Save')}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
export default BodyCreateModal;
